import { createSelector } from '@reduxjs/toolkit';

export const selectForm = (state) => state.tasks.form;
export const selectParams = (state) => state.tasks.params;
export const selectData = (state) => state.tasks.data;
export const selectError = (state) => state.tasks.error;
export const selectFetchCounter = (state) => state.tasks.fetchCounter;
export const selectLoading = (state) => Boolean(state.tasks.loading);
export const selectUpdating = (state) => state.tasks.updating;

export const selectTaskById = (taskId) =>
  createSelector([selectData], (data) => {
    return data?.elements?.find(({ id }) => id === taskId);
  });
